import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const CompanyHubSpaceQuery: GraphQLTaggedNode = graphql`
	query CompanyHubSpaceQuery($key: String!) {
		space(key: $key) {
			id
			homepageId
		}
	}
`;
